<template>
  <div class="has-text-centered">
      <transition name="zoom" mode="out-in">
      <div v-if="loading">
        <hr>
        <fa icon="grin-squint-tears" spin class="fa-10x has-text-grey-light" />
        <hr>
        <span class="is-size-3">Verificando su correo electrónico... Por favor espere...</span>
      </div>
      <div v-else-if="!loading && !error">
        <hr>
        <fa icon="smile-wink" class="fa-10x has-text-success" />
        <hr>
        <span class="is-size-3 has-text-success">¡Su correo electrónico ha sido verificado correctamente!</span>
      </div>
      <div v-else>
        <hr>
        <fa icon="grin-beam-sweat" class="fa-10x has-text-danger" />
        <hr>
        <span class="is-size-3 has-text-danger">¡Ops! Ha ocurrido un error durante la verificación de su correo electrónico, por favor intente nuevamente más tarde. Si el error persiste contáctanos.</span>
      </div>
      </transition>
  </div>
</template>

<script>
export default {
    name:'EmailConfirmView',
    data:()=>({
        loading:true,
        error:false
    }),
    computed: {
        api() {
            return this.$store.getters.GetApiPath
        }
    },
    async mounted() {
        const key = this.$route.params.key
        try {
            await this.axios.post(this.api+'/verify-email/', {key:key})
            this.loading = false
        } catch (e) {
            this.error = true
            this.loading = false
        }
    }
}
</script>

<style>

</style>